var fonts = {
    regular: 'Lato, sans-serif',
    bold: 'Lato, sans-serif',
    italic: 'Lato, sans-serif',
};
var fontWeights = ['400', '700'];
fontWeights.normal = fontWeights[0];
fontWeights.bold = fontWeights[1];
var fontStyles = ['italic', 'inherit'];
fontStyles.italic = fontStyles[0];
fontStyles.inherit = fontStyles[1];
var lineHeights = {
    h1: [1.3, 1.3, 1.3, 1.3],
    h2: [1.3, 1.3, 1.3, 1.3],
    h3: [1.3, 1.3, 1.3, 1.3],
    h4: [1.3, 1.3, 1.3, 1.3],
    h5: [1.3, 1.3, 1.3, 1.3],
    h6: [1.3, 1.3, 1.3, 1.3],
    xl: [1.4, 1.4, 1.3, 1.3],
    lg: [1.5, 1.5, 1.5, 1.5],
    md: [1.5, 1.5, 1.5, 1.5],
    sm: [1.5, 1.5, 1.5, 1.5],
    xs: [1.5, 1.5, 1.5, 1.5],
    label: [1.5, 1.5, 1.5, 1.5],
};
export { fonts, fontWeights, fontStyles, lineHeights };
//# sourceMappingURL=fontStyles.js.map